import React from 'react'
import Start from './Component/Start'
import Heading from './Component/Heading'

function App() {

  return (
   <div>
    <Start />
  </div>
  )
}

export default App
